declare const FeLibrary: {
  Tooltip: {
    getOrCreateInstance: (element: HTMLElement) => {
      show: () => void;
      update: () => void;
      dispose: () => void;
    };
  };
};

export default class Tooltip {
  /**
   * Initializes the tooltip element.
   * @param {any} elementRef The element reference.
   */
  static initialize(elementRef: any) {
    if (elementRef != null)
      FeLibrary?.Tooltip?.getOrCreateInstance(elementRef);
  }

  /**
   * Shows the tooltip.
   * @param {any} elementRef The element reference.
   */
  static show(elementRef: any) {
    if (elementRef != null)
      FeLibrary?.Tooltip?.getOrCreateInstance(elementRef)?.show();
  }

  /**
   * Updates the tooltip.
   * @param {any} elementRef The element reference.
   */
  static update(elementRef: any) {
    if (elementRef != null)
      FeLibrary?.Tooltip?.getOrCreateInstance(elementRef)?.update();
  }

  /**
   * Disposes the tooltip.
   * @param {any} elementRef The element reference.
   */
  static dispose(elementRef: any) {
    if (elementRef != null)
      FeLibrary?.Tooltip?.getOrCreateInstance(elementRef)?.dispose();
  }
}
